import store from '@/store';

/**
 * If user was previously logged in then the last organisation id he was accessing will be saved to localStorage under userId key.
 * If this is the first time user is logging in on the machine or someone has cleared the localStorage then first organisation id is returned.
 */
function getLastOrgId() {
  const userId = store.getters['user/id'];

  let targetOrganisationId = store.getters['organisation/organisationList'] && store.getters['organisation/organisationList'][0] ? store.getters['organisation/organisationList'][0].id : null;
  let lastOrganisationObject = {};

  try {
    lastOrganisationObject = JSON.parse(localStorage.getItem('lastOrganisationInFocus'));
  } catch {
    lastOrganisationObject = {};
  }

  if (lastOrganisationObject) {
    Object.keys(lastOrganisationObject).forEach((key) => {
      if (!key) {
        delete lastOrganisationObject[''];
        localStorage.setItem('lastOrganisationInFocus', JSON.stringify(lastOrganisationObject));
      }
    });
  }

  if (lastOrganisationObject && lastOrganisationObject[userId]) {
    targetOrganisationId = lastOrganisationObject[userId];
  }

  return targetOrganisationId;
}

/**
 * Saves last viewed organisation for a user so it can be loaded on next login.
 */
function saveLastOrgId() {
  const lastUserId = store.getters['user/lastUserId'];
  const currentOrganisation = store.getters['organisation/currentOrganisation'];

  let lastOrganisationObject;

  try {
    const lastOrganisationFromLocalStorage = localStorage.getItem('lastOrganisationInFocus');
    lastOrganisationObject = JSON.parse(lastOrganisationFromLocalStorage);
    if (!lastOrganisationObject) {
      lastOrganisationObject = {};
    }
  } catch (error) {
    lastOrganisationObject = {};
  }

  if (lastUserId) {
    lastOrganisationObject[lastUserId] = currentOrganisation.id;
  }
  localStorage.setItem('lastOrganisationInFocus', JSON.stringify(lastOrganisationObject)); // Object with userId as key and orgId as value
}

export { getLastOrgId, saveLastOrgId };
